module.exports = __webpack_public_path__ + "img/pizza-2.c7ecdf3e.jpg";